import moment from 'moment';

export class DateParser {
  static toISOString(date: Date) {
    return moment(date).toISOString();
  }

  static toString(date: Date | undefined, emptyValue?: string) {
    if (date) {
      return moment(date).format(this.dateFormatMoment);
    }

    return emptyValue ? emptyValue : '';
  }

  static toDateTimeString(date: Date | undefined, emptyValue?: string) {
    if (date) {
      return moment(date).format(this.dateTimeFormatMoment);
    }

    return emptyValue ? emptyValue : '';
  }

  static toReadableDateTimeString(
    date: Date | undefined,
    locale?: string,
    emptyValue?: string,
    options?: { includeSeconds?: boolean }
  ) {
    if (date) {
      return new Intl.DateTimeFormat(locale, {
        dateStyle: 'medium',
        timeStyle: options?.includeSeconds ? 'medium' : 'short'
      }).format(date);
    }

    return emptyValue ? emptyValue : '';
  }

  static readonly dateTimeFormatMoment = 'DD/MM/yyyy hh:mm';
  static readonly dateFormatMoment = 'DD/MM/yyyy';
  static readonly dateFormat = 'dd/MM/yyyy';
}

export default DateParser;
